const cacPalette = () => {
  return [
    // use for Rows and Columns
    {
      use: 'rc',
      name: 'blue',
      pale: '#C5D4FF',
      light: '#8FACFF',
      medium: '#3452FF',
      dark: '#102290',
    },
    {
      use: 'rc',
      name: 'purple',
      pale: '#DFBCFD',
      light: '#C37CFF',
      medium: '#8900FE',
      dark: '#6A1388',
    },
    {
      use: 'rc',
      name: 'pink',
      pale: '#FFC0F2',
      light: '#FF87E6',
      medium: '#FD2CD0',
      dark: '#A9046C',
    },
    {
      use: 'rc',
      name: 'red',
      pale: '#FF9AAF',
      light: '#FF6585',
      medium: '#F2003B',
      dark: '#990002',
    },
    {
      use: 'rc',
      name: 'orange',
      pale: '#FFCC88',
      light: '#FFB34D',
      medium: '#FF7300',
      dark: '#B06001',
    },
    {
      use: 'rc',
      name: 'green',
      pale: '#CFFFAB',
      light: '#A5FF62',
      medium: '#4E9700',
      dark: '#344D0C',
    },
    {
      use: 'rc',
      name: 'teal',
      pale: '#A5FFEF',
      light: '#62FFE3',
      medium: '#009B93',
      dark: '#005D4B',
    },
    // use for Passive
    {
      use: 'p',
      name: 'black',
      pale: '#000000',
      light: '#000000',
      medium: '#000000',
      dark: '#000000',
    },
    {
      use: 'p',
      name: 'gray1',
      pale: '#333333',
      light: '#333333',
      medium: '#333333',
      dark: '#333333',
    },
    {
      use: 'p',
      name: 'gray2',
      pale: '#666666',
      light: '#666666',
      medium: '#666666',
      dark: '#666666',
    },
    {
      use: 'p',
      name: 'gray3',
      pale: '#999999',
      light: '#999999',
      medium: '#999999',
      dark: '#999999',
    },
    {
      use: 'p',
      name: 'gray4',
      pale: '#CCCCCC',
      light: '#CCCCCC',
      medium: '#CCCCCC',
      dark: '#CCCCCC',
    },
    {
      use: 'p',
      name: 'gray5',
      pale: '#747474',
      light: '#747474',
      medium: '#747474',
      dark: '#747474',
    },
    {
      use: 'p',
      name: 'gray6',
      pale: '#EEEEEE',
      light: '#EEEEEE',
      medium: '#EEEEEE',
      dark: '#EEEEEE',
    },
    {
      use: 'p',
      name: 'yellow',
      pale: '#FCFF62',
      light: '#FCFF62',
      medium: '#FCFF62',
      dark: '#FCFF62',
    },
  ];
};

export default cacPalette;
